export const templateType = {
    email: 'email',
    sms: 'sms',
};

export default templateType;
